module.exports = __webpack_public_path__ + "img/map_parking.0b3b542b.png";